import {
  BY_COMPANY_SORT_PROPERTY_CHANGE,
  BY_COMPANY_TYPE_FILTER_CHANGE,
  WHITELIST_ADD_ASYNC,
  WHITELIST_DELETE_SELECTED_ASYNC,
  WHITELIST_EDIT_ASYNC,
  WHITELIST_GET_ASYNC,
  WHITELIST_PAGE_CHANGE,
  WHITELIST_SEARCH_FILTER_CHANGE,
  WHITELIST_SELECT_ALL,
  WHITELIST_SELECT_TOGGLE,
  WHITELIST_UNSELECT_ALL,
} from './constants'

const getWhitelisted = () => ({ type: WHITELIST_GET_ASYNC.INITIATE })
export const getWhitelistedSuccess = (data) => ({
  type: WHITELIST_GET_ASYNC.SUCCESS,
  payload: { data },
})
export const getWhitelistedError = (error) => ({
  type: WHITELIST_GET_ASYNC.ERROR,
  error,
})
const getWhitelistedCancel = () => ({ type: WHITELIST_GET_ASYNC.CANCEL })

const addWhitelist = (data) => ({
  type: WHITELIST_ADD_ASYNC.INITIATE,
  payload: { data },
})
export const addWhitelistSuccess = () => ({ type: WHITELIST_ADD_ASYNC.SUCCESS })
export const addWhitelistError = (error) => ({
  type: WHITELIST_ADD_ASYNC.ERROR,
  error,
})
const addWhitelistCancel = () => ({ type: WHITELIST_ADD_ASYNC.CANCEL })

const editWhitelist = (data) => ({
  type: WHITELIST_EDIT_ASYNC.INITIATE,
  payload: { data },
})
export const editWhitelistSuccess = () => ({
  type: WHITELIST_EDIT_ASYNC.SUCCESS,
})
export const editWhitelistError = (error) => ({
  type: WHITELIST_EDIT_ASYNC.ERROR,
  error,
})
const editWhitelistCancel = () => ({ type: WHITELIST_EDIT_ASYNC.CANCEL })

const deleteSelectedWhitelists = () => ({
  type: WHITELIST_DELETE_SELECTED_ASYNC.INITIATE,
})
export const deleteSelectedWhitelistsSuccess = (deletedIds) => ({
  type: WHITELIST_DELETE_SELECTED_ASYNC.SUCCESS,
  payload: { deletedIds },
})
export const deleteSelectedWhitelistsError = (error) => ({
  type: WHITELIST_DELETE_SELECTED_ASYNC.ERROR,
  error,
})
const deleteSelectedWhitelistsCancel = () => ({
  type: WHITELIST_DELETE_SELECTED_ASYNC.CANCEL,
})

const selectToggle = (id) => ({
  type: WHITELIST_SELECT_TOGGLE,
  payload: { id },
})
const selectAll = (tab) => ({
  type: WHITELIST_SELECT_ALL,
  payload: { tab },
})
const unselectAll = () => ({ type: WHITELIST_UNSELECT_ALL })

const byCompanyTypeFilterChange = (value) => ({
  type: BY_COMPANY_TYPE_FILTER_CHANGE,
  payload: { value },
})
const byCompanySortPropertyChange = (value) => ({
  type: BY_COMPANY_SORT_PROPERTY_CHANGE,
  payload: { value },
})

const pageChange = (value) => ({
  type: WHITELIST_PAGE_CHANGE,
  payload: { value },
})
const searchChange = (value) => ({
  type: WHITELIST_SEARCH_FILTER_CHANGE,
  payload: { value },
})

export default {
  // to props
  getWhitelisted,
  getWhitelistedCancel,
  deleteSelectedWhitelists,
  deleteSelectedWhitelistsCancel,
  addWhitelist,
  addWhitelistCancel,

  editWhitelist,
  editWhitelistCancel,

  byCompanyTypeFilterChange,
  byCompanySortPropertyChange,

  selectToggle,
  selectAll,
  unselectAll,

  pageChange,
  searchChange,
}
